import {FirebaseFeatureToggleAdapter} from '@vizir-banking/banking-app-core/dist/feature-toggle/adapters/firebase-feature-toggle-adapter';

import {REACT_APP_FEATURE_TOGGLE_PREFIX} from '~/env';

export const featureToggleAdapter = new FirebaseFeatureToggleAdapter(
  REACT_APP_FEATURE_TOGGLE_PREFIX,
);
